import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { BuildAbsoluteUrl } from "../../utils/urlBuilder";
function prepareName(name){
    return name.replace(/\"/g, '\'')
}
export default function StructuralDataBreadcrumbs({ breadcrumbs, isCategory, routeData, name }) {
    const location = useLocation();
    
    // Funkcja do dodawania LD+JSON do head
    useEffect(() => {
        if (typeof document !== 'undefined') {
            try {
                // Tworzymy dane strukturalne
                const jsonLd = {
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": []
                };
                
                // Dodajemy elementy do listy
                if (breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
                    breadcrumbs.forEach((item) => {
                        if (item && typeof item === 'object' && item.category_name && item.category_level) {
                            const {category_name, category_level, category_url} = item;
                            jsonLd.itemListElement.push({
                                "@type": "ListItem",
                                "position": category_level - 1,
                                "item": {
                                    "@id": category_url || '',
                                    "name": prepareName(category_name)
                                }
                            });
                        }
                    });
                }
                
                // Dodajemy element dla routeData jeśli to nie kategoria
                if (!isCategory && routeData && routeData.canonical_url) {
                    jsonLd.itemListElement.push({
                        "@type": "ListItem",
                        "position": (breadcrumbs?.length || 0) + 1,
                        "item": {
                            "@id": BuildAbsoluteUrl(routeData.canonical_url),
                            "name": prepareName(routeData.name || '')
                        }
                    });
                }
                
                // Dodajemy aktualną pozycję
                if (routeData || name) {
                    jsonLd.itemListElement.push({
                        "@type": "ListItem",
                        "position": isCategory ? (breadcrumbs?.length || 0) + 1 : (breadcrumbs?.length || 0) + 2,
                        "item": {
                            "@id": BuildAbsoluteUrl(location.pathname),
                            "name": isCategory ? 
                                prepareName(routeData?.name || '') : 
                                prepareName(name || '')
                        }
                    });
                }
                
                // Tylko jeśli mamy jakieś elementy
                if (jsonLd.itemListElement.length > 0) {
                    // Usuwamy poprzedni skrypt, jeśli istnieje
                    const existingScript = document.querySelector('script[data-breadcrumbs-json]');
                    if (existingScript) {
                        existingScript.remove();
                    }
                    
                    // Tworzymy nowy element skryptu
                    const script = document.createElement('script');
                    script.setAttribute('type', 'application/ld+json');
                    script.setAttribute('data-breadcrumbs-json', 'true');
                    script.textContent = JSON.stringify(jsonLd);
                    document.head.appendChild(script);
                }
            } catch (error) {
                console.error('Error creating breadcrumbs schema:', error);
            }
        }
    }, [breadcrumbs, isCategory, routeData, name, location.pathname]);
    
    // Ten komponent nie renderuje nic
    return null;
}